export enum PaymentsStatusEnum {
  All = 0, // Alla
  Completed = 2,
  AgLowBalance = 91, // Täckning saknas
  AgNoApproval = 92, // Koppling saknas
  AgWillRetry = 99, // Förnyad täckning
}

export const FAILED_STATUSES = [PaymentsStatusEnum.AgLowBalance, PaymentsStatusEnum.AgNoApproval, PaymentsStatusEnum.AgWillRetry];
